module.exports = __webpack_public_path__ + "static/media/vimeo-back-side.023e12db.jpg";